import React from 'react';
import PropTypes from 'prop-types';
import { ICONS } from 'constants/icons';

import SuccessReport from './SuccessReport';

import messages from '../ReservationFeedbackModalV2.messages';

const guidelines = [
  {
    icon: ICONS.dollar,
    iconModifier: 'brand',
    title: messages.successGuidelinePayoutTitle,
    description: messages.successGuidelinePayoutDescription,
  },
  {
    icon: ICONS.searchGlasBlue,
    title: messages.successGuidelineInvestigationTitle,
    description: messages.successGuidelineInvestigationDescription,
  },
  {
    icon: ICONS.brokenLink,
    title: messages.successGuidelineEnforcementTitle,
    description: messages.successGuidelineEnforcementDescription,
  },
];

const PaidSuccessReport = ({ venueId, reservationId }) => (
  <SuccessReport
    guidelines={guidelines}
    payoutBannerIcon={ICONS.megaphoneGreen}
    payoutBannerMessage={messages.successPayoutBanner}
    venueId={venueId}
    reservationId={reservationId}
  />
);

PaidSuccessReport.propTypes = {
  venueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  reservationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PaidSuccessReport;
